
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component({
  name: 'CommonAcf',
})
export default class CommonAcf extends Vue {
  @Prop([Object]) readonly block: any
}
